import React, { FC } from 'react'
import { Box, IconButton, Tooltip, Typography, keyframes, useTheme } from '@mui/material'
import { alpha } from '@mui/material/styles'
import MenuIcon from '@mui/icons-material/Menu'
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'

type ChatHeaderProps = {
    onMenuClick: () => void
}

const pulse = keyframes`
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.2); }
`

const ChatHeader: FC<ChatHeaderProps> = ({ onMenuClick }) => {
    const theme = useTheme()

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                px: 2,
                py: 1.5,
                borderBottom: 1,
                borderColor: 'divider',
                bgcolor: alpha(theme.palette.background.paper, 0.85),
                backdropFilter: 'blur(12px)',
            }}
        >
            <Tooltip title="Conversas" placement="bottom">
                <IconButton
                    onClick={onMenuClick}
                    aria-label="Abrir conversas"
                    sx={{ display: { xs: 'flex', md: 'none' } }}
                >
                    <MenuIcon />
                </IconButton>
            </Tooltip>
            <Box
                sx={{
                    width: 40,
                    height: 40,
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: 'primary.main',
                    color: theme.palette.primary.contrastText,
                    boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.25)}`,
                }}
            >
                <AutoAwesomeIcon sx={{ fontSize: 20 }} />
            </Box>
            <Box sx={{ flex: 1 }}>
                <Typography
                    variant="subtitle1"
                    fontWeight={600}
                    lineHeight={1.3}
                    sx={{ fontFamily: theme.typography.fontFamilyDisplay }}
                >
                    Cléo
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                    <Box
                        sx={{
                            width: 7,
                            height: 7,
                            borderRadius: '50%',
                            bgcolor: 'success.main',
                            animation: `${pulse} 2s ease-in-out infinite`,
                        }}
                    />
                    <Typography variant="caption" color="text.secondary" lineHeight={1}>
                        Assistente de formulação · online
                    </Typography>
                </Box>
            </Box>
            <Box
                component="span"
                sx={{
                    px: '9px',
                    py: '3px',
                    borderRadius: '100px',
                    fontSize: '10px',
                    fontWeight: 600,
                    letterSpacing: '1px',
                    bgcolor: 'brand.cream',
                    color: 'primary.main',
                    border: '1px solid',
                    borderColor: alpha(theme.palette.primary.main, 0.3),
                }}
            >
                IA
            </Box>
        </Box>
    )
}

export default ChatHeader